import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { BranchQueryKeys } from './branchQueryKeys';

export const useDeleteBranchMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, string>({
        mutationFn: (id) => apiClient.branches.deleteBranch(id),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: BranchQueryKeys.all,
                });
            }
        },
    });
};
